import { inject, Injectable } from '@angular/core';
import { EnvironmentLoaderService } from './environment-loader.service';
import { HttpClient } from '@angular/common/http';
import { ChargingTransaction } from 'src/app/features/charging-station-location/charging-station-location-model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TransactionsService {
  private environmentLoaderService = inject(EnvironmentLoaderService);
  private httpClient = inject(HttpClient);

  apiURL: string;

  constructor() {
    this.apiURL = `${this.environmentLoaderService.config['serviceBaseUrl']}/api/v1/admin/transactions`;
  }

  public getTransactions(): Observable<ChargingTransaction[]> {
    const url = `${this.apiURL}`;

    return this.httpClient.get<ChargingTransaction[]>(url);
  }
}
